import * as React from 'react';
import { RemovalConfirmConstants as ui } from '../Config/UIConstants';
import { colors } from '../styles/colors';
import { ModalActionButton } from './ModalActionButton';

interface IProps {
    headerText: string;
    subHeaderText: string;
    onClickRemove(): void;
    onClickCancel(): void;
    cancelText?: string;
    removeText?: string;
}

export class RemovalConfirmationPopup extends React.Component<IProps> {
    public render() {
        return (
            <div style={styles.absoluteFill}>
                <div style={styles.innerContainer}>
                    <p style={styles.headerText}>{this.props.headerText}</p>
                    <p style={styles.subHeaderText}>{this.props.subHeaderText}</p>
                    <div style={styles.buttonContainer}>
                        <ModalActionButton fontStyle={styles.buttonFont} onClick={this.props.onClickRemove}
                                           buttonText={this.props.removeText || ui.REMOVE_TEXT} isCancel={true}/>
                        <ModalActionButton
                            buttonStyle={styles.cancelButton}
                            fontStyle={{...styles.buttonFont, ...styles.cancelButtonText}}
                            buttonText={this.props.cancelText || ui.CANCEL_TEXT}
                            onClick={this.props.onClickCancel}/>
                    </div>
                </div>
            </div>
        );
    }
}

const styles = {
    buttonFont: {
        fontSize: 14
    },
    absoluteFill: {
        position: 'fixed',
        top: -300,
        left: -300,
        right: -300,
        bottom: -300,
        zIndex: 999,
        backgroundColor: colors.DARK_BACKGROUND,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    } as React.CSSProperties,
    innerContainer: {
        width: 550,
        backgroundColor: colors.LIGHT_GREY,
        display: 'flex',
        flexDirection: 'column',
        padding: 25
    } as React.CSSProperties,
    headerText: {
        width: '100%',
        textAlign: 'center',
        fontSize: 18,
        fontWeight: 'bold',
        marginTop: 25,
        paddingLeft: 10,
        paddingRight: 10,
        color: '#444648'
    } as React.CSSProperties,
    subHeaderText: {
        width: '100%',
        textAlign: 'center',
        fontSize: 16,
        opacity: 0.7,
        marginTop: 5,
        whiteSpace: 'pre-line',
        marginBottom: 5
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'space-around',
        padding: 25
    } as React.CSSProperties,
    removeButton: {
        height: 50,
        borderRadius: 5,
        width: 160,
        backgroundColor: colors.CANCEL_TEXT
    },
    cancelButton: {
        backgroundColor: colors.ACTION_GREEN
    },
    cancelButtonText: {
        color: colors.WHITE
    }
} as {[key: string]: React.CSSProperties};



// WEBPACK FOOTER //
// ./src/SharedComponents/RemovalConfirmationPopup.tsx